import React, { useMemo } from 'react';
import clsx from 'clsx';
import ShelfRFQProductTemplatesStore, {
  PageStoreContext,
} from 'store/pages/rfq/rfq-template/shelf-rfq-product-templates/pageStore';
import ShelfRFQProductTemplatesTable from 'components/rfq/product-template/shelf-rfq-product-templates/ShelfRFQProductTemplatesTable';
import { PageHeader } from '@insurancemenu/imenu-components-lib';
import { useHistory } from 'react-router-dom';
import { createStyles } from '../../../../globalStyles';

const ShelfRFQProductTemplatesPage: React.FC = () => {
  const history = useHistory();
  const pageStore = useMemo(() => new ShelfRFQProductTemplatesStore(), []);
  const classes = createStyles();

  const onBackButtonClick = (): void => {
    history.push('/product-templates');
  };

  return (
    <div className={clsx(classes.pageWrapper, classes.widePageWrapper)}>
      <PageStoreContext.Provider value={pageStore}>
        <PageHeader title="UW Shelf Product Templates" onBackButtonClick={onBackButtonClick} />
        <ShelfRFQProductTemplatesTable />
      </PageStoreContext.Provider>
    </div>
  );
};

export default ShelfRFQProductTemplatesPage;
